//  TODO: More styling and some images should be added to this message later
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService, LoginData } from "../../services/auth.service";
import Auth from "@aws-amplify/auth";
import { RestService } from "../../services/rest.service";
import { AppConfigService, AppConfig } from "../../services/app-config.service";
import { localUserInfo, globalStore } from "api";
import { forkJoin } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
    selector: "app-page-login-cognito",
    templateUrl: "./page-login-cognito.component.html"
    // styleUrls: ['./page-login-cognito.component.scss']
})
export class PageLoginCognitoComponent implements OnInit {
    constructor(
        private router: Router,
        private auth: AuthService,
        private rest: RestService,
        private appConfigService: AppConfigService
    ) { }

    public errorMessage = "";
    public username = "";
    private count = 0;

    ngOnInit() {
        this.checkLogin();
    }

    checkLogin() {
        if (this.appConfigService.isB2cEnabled()) {
            this.checkB2CLogin();
        }
        else {
            this.checkCognitoLogin();
        }
    }

    checkCognitoLogin() {
        let watchDog = true;
        const t0 = performance.now();
        console.log(`Start checking with cognito, round ${this.count}, timestamp: ${t0}`);
        setTimeout(() => {
            if (watchDog) {
                this.count++;
                console.log(`Watchdog is triggered ${this.count} times`);

                if (this.count < 7) {
                    this.checkCognitoLogin();
                }
            }
        }, 5000);

        Auth.currentAuthenticatedUser({ bypassCache: false })
            .then(user => {
                watchDog = false;
                console.log(`Successfully get Cognito user login data in ${performance.now() - t0} miliseconds`);
                const {
                    signInUserSession = { accessToken: {} },
                    attributes = {}
                } = user;

                this.auth.setToken(signInUserSession.accessToken.jwtToken);
                // TODO: FIX RACE CONDITION!!!
                globalStore.fetchAfterLogin();
                
            })
            .catch(err => {
                console.log('catch -> ', err);
                watchDog = false;
                console.log(`Get failed Cognito user login data response in ${performance.now() - t0} miliseconds. Error - ${err.message}`);
                this.logOutCognito();

                const config: AppConfig = this.appConfigService.getConfig();
                const { urlParams, amplifyParams, oauth } = config.cognito;
                const url = `${urlParams.host}${urlParams.endpoint}?response_type=${oauth.responseType}&client_id=${amplifyParams.aws_user_pools_web_client_id}&redirect_uri=${oauth.redirectSignIn}`;

                window.location.assign(url); // https://authn.lqx.ninja/login?response_type=token&client_id=7b4il73s3u34njps2mnp0pmh8b&redirect_uri=http://localhost:4200/login-cognito/
            });
    }

    checkB2CLogin() {
        this.auth
            .ensureLoggedIn()
            .then(success => {
                const user = JSON.parse(localStorage.getItem('b2c_user')),
                    b2cToken = localStorage.getItem('b2c_access_token'),
                    email = user.emails[0];

                this.auth.setToken(b2cToken);
                // TODO: FIX RACE CONDITION!!!
                globalStore.fetchAfterLogin();
                
            })
            .catch(err => {
                console.log('Error on b2c login', err);
                this.logOutB2C();
            });
    }

    logOutCognito() {
        this.auth.removeLocalStorage();

        Auth.signOut()
            .then(data => console.log(data))
            .catch(err => console.log(err));

        return true;
    }

    logOutB2C() {
        this.auth.removeLocalStorage();
        this.auth.msalLogout();
        return true;
    }

    logOut() {
        if (this.appConfigService.isB2cEnabled()) {
            this.logOutB2C();
        }
        else {
            this.logOutCognito();
        }
    }
}
